//namespace Pacem {
export class Blobs {
    static blobToDataURL(blob) {
        return new Promise((resolve, _) => {
            const a = new FileReader();
            a.onload = (e) => { resolve(e.target.result); };
            a.readAsDataURL(blob);
        });
    }
    static _b64ToUint8Array(bstr) {
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return u8arr;
    }
    static base64ToBlob(bstr, options) {
        const u8arr = Blobs._b64ToUint8Array(atob(bstr));
        return new Blob([u8arr], options);
    }
    static dataURLToBlob(dataurl) {
        const coma = dataurl.indexOf(',');
        if (coma === -1) {
            return Blobs.base64ToBlob(dataurl);
        }
        else {
            const bstr = dataurl.substring(coma + 1), data = dataurl.substring(0, coma);
            const mime = data.match(/:(.*?);/)[1];
            return Blobs.base64ToBlob(bstr, { type: mime });
        }
    }
    static async blobToText(blob, encoding) {
        const buffer = await blob.arrayBuffer();
        const decoder = new TextDecoder(encoding, { fatal: false });
        return decoder.decode(buffer);
    }
    static textToBlob(content, type = 'text/plain', charset = 'utf-8', bom, lossyChar = 0x3F) {
        let charsetLower = charset.toLowerCase();
        const fullType = () => `${type};charset=${charsetLower}`;
        switch (charsetLower) {
            // -------------------------
            // UTF-8 (native, safe)
            // -------------------------
            case 'utf-8': {
                const encoder = new TextEncoder();
                const bytes = encoder.encode(content);
                const parts = bom
                    ? [new Uint8Array([0xEF, 0xBB, 0xBF]), bytes]
                    : [bytes];
                return new Blob(parts, { type: fullType() });
            }
            // -------------------------
            // UTF-16 (explicit LE/BE)
            // -------------------------
            case 'utf-16':
                // Treat as UTF-16LE with BOM (common convention)
                charsetLower = 'utf-16le';
                bom ??= true;
            case 'utf-16le':
            case 'utf-16be': {
                const littleEndian = charsetLower !== 'utf-16be';
                const offset = bom ? 1 : 0;
                const buffer = new ArrayBuffer((content.length + offset) * 2);
                const view = new DataView(buffer);
                if (bom) {
                    view.setUint16(0, 0xFEFF, littleEndian);
                }
                for (let i = 0; i < content.length; i++) {
                    view.setUint16((i + offset) * 2, content.charCodeAt(i), littleEndian);
                }
                return new Blob([buffer], {
                    type: fullType()
                });
            }
            // -------------------------
            // Latin-1 (ISO-8859-1)
            // -------------------------
            case 'ascii':
            case 'iso-8859-1':
            case 'latin1': {
                const boundary = charsetLower === 'ascii' ? 0x7F : 0xFF;
                const buffer = new Uint8Array(content.length);
                const lossy = lossyChar > 0;
                for (let i = 0; i < content.length; i++) {
                    const code = content.charCodeAt(i);
                    if (code > boundary) {
                        if (lossy) {
                            buffer[i] = lossyChar; // ? char
                        }
                        else {
                            throw new Error(`Character "${content[i]}" cannot be encoded in ${charset}.`);
                        }
                    }
                    else {
                        buffer[i] = code;
                    }
                }
                return new Blob([buffer], { type: fullType() });
            }
            // -------------------------
            // Explicitly unsupported
            // -------------------------
            default:
                throw new Error(`Encoding "${charset}" is not supported safely in the browser. ` +
                    `Use UTF-8 or any supported encoding.`);
        }
    }
}
//}
